import { Stack, Text } from "@chakra-ui/layout";
import { useDisclosure } from "@chakra-ui/hooks";
import { useIntercom } from "react-use-intercom";

import AccountLink from "../AccountLink/AccountLink";
import ProfileShortInfo from "../ProfileShortInfo/ProfileShortInfo";
import { useClaimReward } from "contexts/claimReward";

import RewardIcon from "assets/png/gift.png";
import Bank from "assets/svg/icons-new/banks.svg";
import Edit from "assets/svg/icons-new/edit.svg";
import Support from "assets/svg/icons-new/support.svg";
// import Refer from "assets/svg/icons-new/refer.svg";
import VerificationIcon from "assets/svg/verification.svg";
import NotificationIcon from "assets/svg/notification.svg";
import Logout from "assets/icons/log-out.svg";
import MobileMoneyIcon from "assets/svg/call.svg";
import PartnersIcon from "assets/png/business-affiliate-network.png";

import Confirm from "../Modals/p2p/Confirmation";

const links = [
  {
    name: "Edit",
    id: "edit",
    link: "/dashboard/account/edit",
    icon: Edit,
  },
  {
    name: "Banks and Cards",
    id: "banks",
    link: "/dashboard/account/banks",
    icon: Bank,
  },
  {
    name: "Mobile Money",
    id: "mobilemoney",
    link: "/dashboard/account/mobilemoney",
    icon: MobileMoneyIcon,
  },
  {
    name: "Bitmama Partners",
    id: "partners",
    link: "/dashboard/account/partners",
    icon: PartnersIcon,
  },
  {
    name: "Verification",
    id: "verification",
    link: "/dashboard/account/verification",
    icon: VerificationIcon,
  },
  {
    name: "Crypto Price Alert",
    id: "pricealert",
    link: "/dashboard/account/pricealert",
    icon: NotificationIcon,
  },
  // {
  //   name: "Refer a friend",
  //   id: "refer",
  //   link: "/dashboard/account/refer",
  //   icon: Refer,
  // },
];

const AccountSidebar = ({ current, userData, logout, ...props }) => {
  const { boot } = useIntercom();
  const { onOpen } = useClaimReward();

  const { isOpen, onClose, onOpen: openLogout } = useDisclosure();

  const bootWithProps = () =>
    boot({
      name: userData.firstName,
      userId: userData.userId,
      email: userData.email,
      phone: userData.phone || undefined,
      createdAt: userData.createdAt,
    });

  const handleLogout = () => {
    logout && logout();
    logout && (window.location = "/");
  };

  return (
    <Stack gridGap="14px" className="none" {...props}>
      <ProfileShortInfo
        fullName={userData?.fullName}
        verified={userData?.verified}
        kycLevel={userData?.kycLevel}
      />

      <Stack gridGap="4px">
        {links.map((item, i) => (
          <AccountLink
            key={`account-link-${i}`}
            to={item.link}
            icon={item.icon}
            current={item.id === current}
          >
            {item.name}
          </AccountLink>
        ))}

        <AccountLink onClick={onOpen} icon={RewardIcon}>
          Claim Rewards
        </AccountLink>

        <AccountLink onClick={() => bootWithProps()} icon={Support}>
          Support
        </AccountLink>

        <AccountLink onClick={openLogout} icon={Logout}>
          Logout
        </AccountLink>
      </Stack>

      <Confirm
        isOpen={isOpen}
        onClose={onClose}
        title="Confirm"
        onConfirm={handleLogout}
        buttonText={["Close", "Logout"]}
      >
        <Text textAlign="center">Are you sure you want to logout?</Text>
      </Confirm>
    </Stack>
  );
};

export default AccountSidebar;
